import { render } from "./AttendanceUploading.vue?vue&type=template&id=35b71c10"
import script from "./AttendanceUploading.vue?vue&type=script&lang=js"
export * from "./AttendanceUploading.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__